import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useBlockScroll } from '../../hooks/useBlockScroll';

const Modal = ({
  allowScroll,
  isOpen,
  shouldScroll,
  isOneTap,
  onClickOverlay,
  children,
  modalCustomWidth,
  noBlur = false,
  extraMargin = 0,
  noPadding = false,
}) => {
  const modalWidth = modalCustomWidth ? { width: `${modalCustomWidth}px` } : {};

  if (!(allowScroll ?? false)) {
    useBlockScroll(isOpen, shouldScroll);
  }

  const ref = useRef(null);
  const backgroundStyle = noBlur ? {} : { backdropFilter: 'blur(2px)' };

  return createPortal(
    <CSSTransition
      classNames="modal-container"
      style={backgroundStyle}
      in={isOpen}
      mountOnEnter={true}
      unmountOnExit={true}
      appear={true}
      timeout={200}
    >
      <div
        key="modal"
        className={cn('modal-container', {
          'one-tap': isOneTap,
        })}
        ref={ref}
        onMouseDown={(e) => ref.current === e.target && onClickOverlay()}
      >
        <div
          className={cn('grid-container', 'fluid', 'modal')}
          style={!!extraMargin && isOneTap ? { marginTop: `${extraMargin}rem` } : modalWidth}
        >
          <div
            className="scrollbox__outer"
            style={{
              ...(modalCustomWidth ? { width: '100%' } : {}),
              ...(noPadding ? { padding: 0, margin: 0 } : {}),
            }}
          >
            <div className="scrollbox__inner" style={noPadding ? { padding: 0, margin: 0 } : {}}>{children}</div>
          </div>
        </div>
      </div>
    </CSSTransition >,
    document.body
  );
};

Modal.propTypes = {
  shouldScroll: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClickOverlay: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

Modal.defaultProps = {
  shouldScroll: true,
  isOneTap: false,
};

export { Modal };
